import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      Entre los pascas no hay otro joven como Zuhé. A sus catorce años, conoce los secretos de los reyes y los
      sacerdotes indígenas: Sabe callar y, como nadie, sabe escuchar. Tiene la paciencia y la quietud de los mejores
      cazadores, la resistencia de un animalito de monte, la fuerza y sagacidad de un guerrero.
    </p>
    <p className="content justified">
      Y Zuhé, a quien también llaman Cupupca –caracol–, es el protagonista de una de las historias juveniles más
      extensas que Oswaldo Díaz Díaz publicó y en la que, como es propio de este autor, se enaltece la voz de los héroes
      silenciados.
    </p>
    <p className="content justified">
      ¿Qué habría sido de la conquista española si el joven Cupupca no hubiera llevado el mensaje de Lázaro Fonte a
      Gonzalo Jiménez de Quesada, donde advierte que Nicolás de Federmann y una expedición alemana se acercan por el
      oriente? “Tal vez sin estos acontecimientos la conquista del Nuevo Reino de Granada hubiera sido obra de alemanes
      y flamencos y no de españoles” (p. 185), tantea Don Os.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Pero esa, en todo caso, no es una buena noticia para el joven pasca. “Para él tales cosas solo significaban que el
      poderío extranjero se hacía más fuerte en el valle y que la independencia de los indígenas estaba cada vez más
      comprometida” (185).
    </p>
  </div>
);

export const sections = (
  <div className="sectionsReview">
    <div className="sectionReview">
      <h3 className="review-title subtitle">Un cuento en doce secciones</h3>
      <p className="content justified">
        Generalmente las historias infantiles y juveniles de Oswaldo Díaz Díaz no superaban las cuatro páginas, pero con
        “Zuhé” el autor se toma su tiempo en contextualizar a los lectores y mostrarles distintos momentos de la
        conquista.
      </p>
      <p className="content justified">
        Un ejército de más de setecientos soldados sale de Santa Marta, pero apenas llegan ciento sesenta y seis a las
        tierras de lo que hoy conocemos como Cundinamarca.
      </p>
      <p className="content justified">
        Sin demasiados detalles, centrando la narración en las acciones, Don Os señala de dónde venía Cupupca, cómo lo
        entrenaron y a qué tuvo que renunciar para convertirse en uno de los chicos más valerosos de su pueblo.
      </p>
      <p className="content justified">
        Nos muestra las rencillas entre españoles, las trampas, los acercamientos pacíficos a los pueblos nativos y el
        posterior sometimiento de estos. Y narra con detalle la historia de Lázaro Font, su amor con la joven muisca
        Suamena (Zoratama, figura en otras fuentes) y la manera como <i>Zuhé</i> decide ayudarlos.
      </p>
    </div>
    <div className="sectionReview">
      <h3 className="review-title subtitle">Arte, historia y ficción</h3>
      <p className="content justified">
        <i>Cuentos tricolores</i> fue publicado en 1967 con el ánimo de que los niños colombianos tuvieran en sus manos
        un libro que despertara su curiosidad por los temas de la patria. No hay otros libros colombianos con una
        edición tan bellamente cuidada como esta, en la que Sergio Trujillo Magnenat aporta sus ilustraciones.
      </p>
      <p className="content justified">
        Dice el editor: “Ambos presentan al mundo infantil situaciones, hechos y nombres de la historia nacional, con
        leve colorido de leyenda, sin apartarse de la certidumbre y la veracidad histórica”.
      </p>
      <p className="content justified">
        Y es que hay que mencionar que Oswaldo Díaz Díaz fue un gran historiador por vocación (no en vano escribió dos
        de los volúmenes de la <i>Historia extensa de Colombia</i>), pero también se consideró a sí mismo escritor de
        literatura infantil. En un cuento como <i>Zuhé</i>, este autor equilibra esas dos facetas.
      </p>
      <p className="content justified">
        Pues no hay que dudar que, para llegar al punto de redactar este cuento, Don Os visitó muchos archivos, consultó
        diversas fuentes y recreó situaciones desde un punto de vista único, en el que el papel de un indígena como Zuhé
        –un poco a su pesar– es determinante para la historia de Colombia.
      </p>
    </div>
  </div>
);
